module.exports = __webpack_public_path__ + "img/img_tc_tu3.385ce414.png";